module.exports = __webpack_public_path__ + "img/content.1c02a642.svg";